<template>
  <div v-if="activeLanguages.length > 1" class="language-selector">
    <label class="language-label">
      {{ displayLanguageLabel }}
    </label>
    <select 
      v-model="language" 
      class="language-dropdown"
    >
      <option 
        v-for="lang in activeLanguages" 
        :key="lang.code" 
        :value="lang.code"
      >
        {{ lang.flag }} {{ lang.nativeName }}
      </option>
    </select>
  </div>
</template>

<script>
import languageService from '&/services/languageService.js'
import { useLanguage } from '../composables/useLanguage'
import { useConfig } from '../composables/useConfig'

export default {
  name: 'LanguageSelector',
  data() {
    return {
      activeLanguages: []
    }
  },
  setup() {
    const { language } = useLanguage()
    const { getConfigText } = useConfig();

    return {
      language,
      getConfigText
    }
  },
  computed: {
    displayLanguageLabel() {
      return this.getConfigText('general.languageLabel', 'Idioma')
    }
  },
  mounted() {
    this.loadActiveLanguages()
  },
  methods: {
    async loadActiveLanguages() {
      try {
        console.log('🌐 LanguageSelector: Cargando idiomas activos...')
        const response = await languageService.getActiveLanguages()
        
        if (response.success && response.data) {
          this.activeLanguages = response.data
          console.log('✅ LanguageSelector: Idiomas activos cargados:', this.activeLanguages.length)
        } else {
          throw new Error('No se pudieron cargar idiomas activos')
        }
      } catch (error) {
        console.error('❌ LanguageSelector: Error cargando idiomas activos:', error)
        this.activeLanguages = []
      }
    }
  }
}
</script>

<style scoped>
.language-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.language-label {
  font-size: var(--font-size-base);
  font-weight: 500;
  color: white;
  opacity: 0.95;
}

.language-dropdown {
  background: rgba(255, 255, 255, 0.95);
  color: #333;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: var(--button-padding-y) 1rem;
  font-size: var(--body-font-size);
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
}

.language-dropdown:hover {
  background: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.language-dropdown:focus {
  outline: none;
  border-color: #4facfe;
  box-shadow: 0 0 0 3px rgba(79, 172, 254, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .language-selector {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .language-dropdown {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .language-dropdown {
    font-size: var(--form-font-size);
    padding: var(--button-padding-y) var(--button-padding-x);
  }
}
</style>
